import calendarPlugin from "dayjs/plugin/calendar";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMax from "dayjs/plugin/minMax";
import relativeTime from "dayjs/plugin/relativeTime";
import {
  calendarFormat,
  graphqlDateFormat,
  localizedShortDate,
} from "./plugins";

export {
  calendarFormat,
  calendarPlugin,
  duration,
  graphqlDateFormat,
  localizedFormat,
  localizedShortDate,
  minMax,
  relativeTime,
};
